.root {
  display: flex;
  flex-direction: column;
  gap: var(--spacingMd);
}
